export default __webpack_public_path__ + "0a5dd79ac11ab1bca7b4adcc515eecf1.jpg";